// this is going to be global contract in the lib
import { urlFormatter } from "../../contracts";
export const mapLinkUrl = (ajustLive, ajustPreLive, x) => {
    x.linkUrl = "";
    let url = urlFormatter.getEventUrl(x);
    if (x.isLive) {
        x.linkUrl = ajustLive(url);
    }
    else {
        x.linkUrl = ajustPreLive(url);
    }
    return x;
};
//# sourceMappingURL=mapLinkUrl.js.map